var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._g(_vm._b({staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.interviews,"items-per-page":5,"data-test-id":"my-interviews-table"}},'v-data-table',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }